// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D_xZkyw2rI8WBqXHx99C{justify-content:flex-start;width:100%}.BmptrQ5UYUSiXOEPa7K8{background-color:var(--background-primary-inverted-primary);border:1px var(--border-neutral-default)solid;text-overflow:ellipsis;white-space:nowrap;border-radius:6px;max-width:100px;padding:4px 8px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createButton": `D_xZkyw2rI8WBqXHx99C`,
	"createButtonLabel": `BmptrQ5UYUSiXOEPa7K8`
};
export default ___CSS_LOADER_EXPORT___;
